import { makeAutoObservable } from 'mobx';
import { FilterStore } from '../../shared/util-stores';
import {
  ScanIqCustomerListFilterFormValues,
  ScanIqCustomerListFilters,
  ScanIqCustomerListSortFields,
} from '../interfaces/ScanIqCustomerListFilters';
import { resetAllStore } from '../../shared/stores/resetAllStore';
import { ScanIqCustomerListInfo } from '../interfaces/ScanIqCustomerListInfo';
import { scanIqCustomerService } from '../services/scanIqCustomerService';

class ScanIqCustomersListStore {
  customerList: ScanIqCustomerListInfo[] = [];
  filterMethods: FilterStore<
    ScanIqCustomerListFilterFormValues,
    ScanIqCustomerListSortFields
  >;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });

    this.filterMethods = new FilterStore<
      ScanIqCustomerListFilterFormValues,
      ScanIqCustomerListSortFields
    >(this.handleGetCustomerList);
  }

  setDefaultValues() {
    this.customerList = [];
    this.filterMethods.setDefaultValues();
  }

  private async handleGetCustomerList(filterInfo: ScanIqCustomerListFilters) {
    const data = await scanIqCustomerService.getCustomerList(filterInfo);

    this.setCustomerList(data.content);

    return data;
  }

  async getCustomerList() {
    return this.filterMethods.getData();
  }

  setCustomerList(customerList: ScanIqCustomerListInfo[]) {
    this.customerList = customerList;
  }
}

const scanIqCustomerListStore = new ScanIqCustomersListStore();

resetAllStore.addResetMethod(scanIqCustomerListStore.setDefaultValues);

export { scanIqCustomerListStore, ScanIqCustomersListStore };
